import React from 'react';

import "./Instructions.css";

const Instructions = ({activeProjectId}) => {
  return (
    <div className="instructions">
      <div className="heading">Widget code snippet</div>

      <label className="form-label" htmlFor="js-instructions">
        Copy and paste this widget code in the <code className="code-inline">index.html</code> of your project.
      </label>

      <pre className="code-block">
        <code>
          {`<Drawing><drawingId>${activeProjectId}</drawingId></Drawing>`}
        </code>
      </pre>
    </div>
  );
};

export default Instructions;
